<script>
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import MenuIcons from "../components/MenuIcons.svelte";
  import ProfileCard from "../components/ProfileCard.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
 
  function logOut() {
    localStorage.removeItem("t"); 
    window.history.go(0);
  }
</script>
<svelte:head>
<title>Akun - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<Navigationbar backbtn="true" message={navigation['message']} title="Akun" />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div
    class="flex flex-wrap items-center max-w-6xl pt-3 mx-auto lg:my-0 ">
    <!--Main Col-->
    <ProfileCard />
    <!--Img Col-->
    <MenuIcons />
  </div>
  <div class="flex flex-wrap items-center max-w-6xl mx-auto">
    <Title subtitle="" title="Pengguna" />
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/akun/profile"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Perbaharui Profil</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/akun/nomor"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Nomor Ponsel</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>

    <Title subtitle="" title="Jualan" />
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/tokoku"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Kelola Toko</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>

    <Title subtitle="" title="Belanja" />
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/akun/transaksi"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Riwayat Transaksi</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/akun/alamat"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Alamat Pengiriman</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>

    <Title subtitle="" title="Keamanan" />
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/akun/password"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Kelola Kata Sandi</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      href="/akun/email"><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Email Pemulihan</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </a>

    <Title subtitle="" title="Sesi Akun" />
    <button
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-green-700"
      on:click={logOut}><div class="flex items-center justify-between">
        <span class="text-base text-red-600">Logout</span>
        <span
          class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">&gt;</span>
      </div>
    </button>
  </div>
</main>
